import { Card, CardContent, Typography, Box, Grid, Divider } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const AcademicYearStanding = ({ totalPoints, merits, demerits }) => {
    const currentMarkingPeriodId = useSelector(state => state.lookup.currentMarkingPeriodId);
    const markingPeriods = useSelector(state => state.lookup.markingPeriods)?.markingPeriods;
    const { t } = useTranslation();
    const currentMarkingPeriod = markingPeriods?.find(mp => mp.id === currentMarkingPeriodId);
    const tone = totalPoints > 0 ? 'success' : totalPoints < 0 ? 'error' : null;

    return (
        <Card variant="outlined" sx={{ borderRadius: 2, mb: 1.5 }}>
            <CardContent>
                <Box height={55} display={'flex'} alignItems='center'>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {currentMarkingPeriod
                            ? t('{{name}} Points', { name: currentMarkingPeriod.name })
                            : t('Academic Year Standing')}
                    </Typography>
                </Box>
                <Divider sx={{ mb: 2 }} />
                <Box
                    sx={{
                        bgcolor: theme => tone ? alpha(theme.palette[tone].main, 0.12) : theme.palette.action.hover,
                        border: '1px solid',
                        borderColor: theme => tone ? alpha(theme.palette[tone].main, 0.4) : theme.palette.divider,
                        borderRadius: 2,
                        textAlign: 'center',
                        py: 3,
                        mb: 3
                    }}
                >
                    <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1 }}>
                        {t('TOTAL POINTS')}
                    </Typography>
                    <Typography variant="h3" sx={{ color: tone ? `${tone}.main` : 'text.primary', fontWeight: 'bold' }}>
                        {totalPoints > 0 ? `+${totalPoints}` : totalPoints}
                    </Typography>
                </Box>

                <Grid container>
                    <Grid item xs={6} sx={{ textAlign: 'center', borderRight: '1px solid', borderColor: 'divider' }}>
                        <Typography variant="body2" color="text.secondary">{t('MERITS')}</Typography>
                        <Typography variant="h6" sx={{ color: 'success.main' }}>{merits}</Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ textAlign: 'center' }}>
                        <Typography variant="body2" color="text.secondary">{t('DEMERITS')}</Typography>
                        <Typography variant="h6" sx={{ color: 'error.main' }}>{demerits}</Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default AcademicYearStanding;